"use client";

import { isNotAuthorizedPageError } from "@/auth";
import { ClientNotAuthenticated } from "@/auth/components/ClientNotAuthenticated";
import { ErrorLayout } from "@/components/layout/ErrorLayout";
import { Button } from "@deputy-ai/ui/button/Button";
import { useEffect } from "react";
import { BiRefresh } from "react-icons/bi";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  if (isNotAuthorizedPageError(error)) {
    return <ClientNotAuthenticated />;
  }

  return (
    <ErrorLayout>
      <div className="flex justify-center">
        <div className="w-20">
          <ErrorIcon />
        </div>
      </div>
      <h2 className="text-center text-lg font-bold">
        {"Something went wrong, we're on it!"}
      </h2>
      <p className="text-center">
        {"Thanks for your patience. Please try again soon."}
      </p>
      <Button Icon={BiRefresh} onClick={() => reset()} variant="outline">
        Refresh
      </Button>
    </ErrorLayout>
  );
}

function ErrorIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
      <g data-name="Cloud Close">
        <path
          d="M12.5 13a4.5 4.5 0 1 0 4.5 4.5 4.505 4.505 0 0 0-4.5-4.5zm2.5 6.293-.707.707-1.793-1.793L10.707 20 10 19.293l1.793-1.793L10 15.707l.707-.707 1.793 1.793L14.293 15l.707.707-1.793 1.793z"
          fill=":#232326"
        />
        <path
          d="M19.99 7.21a4.49 4.49 0 0 0-8.82-.87A4.158 4.158 0 0 0 9.5 6a4.486 4.486 0 0 0-4.23 3.01A4.498 4.498 0 0 0 5.5 18h1.53a4.07 4.07 0 0 1-.03-.5 5.5 5.5 0 0 1 11 0 4.07 4.07 0 0 1-.03.5h.53a5.497 5.497 0 0 0 1.49-10.79z"
          fill="#232326"
        />
      </g>
    </svg>
  );
}
